package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Floor(
    @SerialName("id")
    val id: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("number")
    val number: Int?,
    @SerialName("objectType")
    val objectType: String?,
    @SerialName("projectId")
    val projectId: String?,
    @SerialName("rooms")
    val rooms: List<Room?>?,
    @SerialName("__typename")
    val typename: String?
)